module.exports = __webpack_public_path__ + "img/java.4e7d34c4.png";